export default __webpack_public_path__ + "static/5-8924ef6d72b5bba241eae0455599dc34.jpeg";